import React, { useState } from "react";
import {Col,Row,Container, Label} from "reactstrap";

const ServicesCardMain = (props) => {
    return (
      <>
        <Col xs={12} lg={12}>
          <div className="text-center mt-4">
            <div className="lighlight-border mt-4"></div>
            <Row className="justify-content-center">
            <Col xs={8}>
            <div className="text-black mt-3 fs-1">{props.caption}</div>
            </Col>
            </Row>
          </div>
        </Col>
        {/* <!--end col--> */}
      </>
    );
  }

export default ServicesCardMain;